// Ohio State's undergraduate majors on the Columbus campus (#2652). Read on
// 2026-10-01 from Undergraduate Admissions' official Majors and degrees page
// (undergrad.osu.edu/majors-and-academics/majors), which lists each major
// with its degree, campus and college. Kept: Columbus campus, bachelor's
// degrees (BA, BS, BFA, BM, BME, BSD, BSEd, or both where the page lists
// "BS, BA"). Left out: associate degrees (ATI Wooster and regional campuses),
// the RN to BSN and dental hygiene degree-completion programs (not first-year
// entry), minors and graduate programs. Group names are the colleges as the
// Enrollment Criteria page names them; flags quote that page (the college
// file's `enrollment` source). En dashes in names became hyphens. The KB's
// majors list was the starting point; the official page wins.
const majors = {
    "slug": "ohio-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major Ohio State lists for the Columbus campus on its official Majors and degrees page, grouped by the college or school that offers it, with the degree it leads to. Associate degrees, degree-completion programs for working nurses and dental hygienists, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Chase Center for Civics, Culture and Society",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Civics, Law and Leadership",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "BS",
                    "flag": "Admitted students start as pre-majors, and admission to this major is competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "African American and African Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Sign Language (ASL): Applied Communication and Community Studies",
                    "degree": "BA"
                },
                {
                    "name": "Ancient History and Classics",
                    "degree": "BA"
                },
                {
                    "name": "Anthropological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Arabic",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA, BFA"
                },
                {
                    "name": "Arts Management",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy and Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS, BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS, BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS, BA"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Studies",
                    "degree": "BA"
                },
                {
                    "name": "Computer and Information Science",
                    "degree": "BS, BA",
                    "flag": "Admitted students start as pre-majors, and admission to this major is competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Criminology and Criminal Justice Studies",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA",
                    "flag": "Enrollment in the pre-major follows a successful audition; audition programs are highly competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Data Analytics",
                    "degree": "BS",
                    "flag": "Admitted students start as pre-majors, and admission to this major is competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Earth Sciences",
                    "degree": "BS, BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS, BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Evolution and Ecology",
                    "degree": "BS"
                },
                {
                    "name": "Experiential Media Design",
                    "degree": "BSD"
                },
                {
                    "name": "Film Studies",
                    "degree": "BA"
                },
                {
                    "name": "Forensic Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geographic Information Science",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BS, BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Hebrew and Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History of Art",
                    "degree": "BA"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BSD"
                },
                {
                    "name": "Interior Design",
                    "degree": "BSD"
                },
                {
                    "name": "International Studies",
                    "degree": "BS, BA",
                    "flag": "Admitted students start as pre-majors, and admission to this major is competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Islamic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Korean",
                    "degree": "BA"
                },
                {
                    "name": "Leadership",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Medical Anthropology",
                    "degree": "BS, BA"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Modern Greek",
                    "degree": "BA"
                },
                {
                    "name": "Molecular Genetics",
                    "degree": "BS"
                },
                {
                    "name": "Moving-Image Production",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BS",
                    "flag": "Enrollment in the pre-major follows a successful audition; audition programs are highly competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Music",
                    "degree": "BA",
                    "flag": "Enrollment in the pre-major follows a successful audition; audition programs are highly competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Music - Education",
                    "degree": "BME",
                    "flag": "Enrollment in the pre-major follows a successful audition; audition programs are highly competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Music - Jazz Studies",
                    "degree": "BM",
                    "flag": "Enrollment in the pre-major follows a successful audition; audition programs are highly competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Music - Performance (orchestral instruments)",
                    "degree": "BM",
                    "flag": "Enrollment in the pre-major follows a successful audition; audition programs are highly competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Music - Performance (piano)",
                    "degree": "BM",
                    "flag": "Enrollment in the pre-major follows a successful audition; audition programs are highly competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Music - Performance (voice)",
                    "degree": "BM",
                    "flag": "Enrollment in the pre-major follows a successful audition; audition programs are highly competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS",
                    "flag": "Admitted students start as pre-majors, and admission to this major is competitive.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics and Economics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BS, BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS, BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Romance Studies",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Social Sciences Air Transportation",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS, BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Speech and Hearing Science",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Visual Communication Design",
                    "degree": "BSD"
                },
                {
                    "name": "Women's, Gender and Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "World Literatures",
                    "degree": "BA"
                },
                {
                    "name": "World Politics",
                    "degree": "BA"
                },
                {
                    "name": "Zoology",
                    "degree": "BS, BA"
                }
            ]
        },
        {
            "name": "College of Education and Human Ecology",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Child and Youth Studies",
                    "degree": "BSEd"
                },
                {
                    "name": "Consumer and Family Financial Services",
                    "degree": "BS"
                },
                {
                    "name": "Education - Integrated Language Arts/English Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Education - Integrated Social Studies",
                    "degree": "BSEd"
                },
                {
                    "name": "Education - Middle Childhood Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Education - Primary Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Education - Science and Mathematics Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Education - Special Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Education - Teaching English to Speakers of Other Languages",
                    "degree": "BSEd"
                },
                {
                    "name": "Exercise Science Education",
                    "degree": "BS"
                },
                {
                    "name": "Fashion and Retail Studies",
                    "degree": "BS"
                },
                {
                    "name": "Health Promotion, Nutrition and Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality Management",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BS"
                },
                {
                    "name": "Human Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Sport Industry",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS",
                    "flag": "A highly competitive major: indicate your interest on the Common Application.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Aviation",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS",
                    "flag": "A highly competitive major: indicate your interest on the Common Application.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Food, Agricultural and Biological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS",
                    "flag": "A highly competitive major: indicate your interest on the Common Application.",
                    "flagSource": "enrollment"
                },
                {
                    "name": "Welding Engineering",
                    "degree": "BS"
                }
            ],
            "note": "Admission to engineering majors is competitive. Admitted students are enrolled directly into their major.",
            "noteSource": "enrollment"
        },
        {
            "name": "College of Food, Agricultural, and Environmental Sciences",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Agribusiness and Applied Economics",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Communication",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Systems Management",
                    "degree": "BS"
                },
                {
                    "name": "Agriscience Education",
                    "degree": "BS"
                },
                {
                    "name": "Animal Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Community Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Construction Systems Management",
                    "degree": "BS"
                },
                {
                    "name": "Entomology",
                    "degree": "BS"
                },
                {
                    "name": "Food Business Management",
                    "degree": "BS"
                },
                {
                    "name": "Food Science and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Horticulture and Crop Science",
                    "degree": "BS"
                },
                {
                    "name": "Plant Pathology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Medicine",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Biomedical Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BS",
                    "flag": "Admitted students who meet selective criteria start as pre-nursing majors; admission to the major is competitive.",
                    "flagSource": "enrollment"
                }
            ]
        },
        {
            "name": "College of Pharmacy",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Public Health",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Social Work",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Division of Dental Hygiene",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "BS",
                    "flag": "Admitted students start as pre-majors, and admission to this major is competitive.",
                    "flagSource": "enrollment"
                }
            ]
        },
        {
            "name": "Fisher College of Business",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Aviation Management",
                    "degree": "BS"
                },
                {
                    "name": "Economics - Business",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Human Resources",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "International Business",
                    "degree": "BS"
                },
                {
                    "name": "Logistics Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Operations Management",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate and Urban Analysis",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "John Glenn College of Public Affairs",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Public Management, Leadership and Policy",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Knowlton School of Architecture",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BS"
                },
                {
                    "name": "City and Regional Planning",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Environment and Natural Resources",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Environment, Economy, Development and Sustainability",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Policy and Decision Making",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Forestry, Fisheries and Wildlife",
                    "degree": "BS"
                },
                {
                    "name": "Natural Resource Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Health and Rehabilitation Sciences",
            "source": {
                "label": "Ohio State Admissions, Majors and degrees",
                "url": "https://undergrad.osu.edu/majors-and-academics/majors"
            },
            "majors": [
                {
                    "name": "Health Information Management and Systems",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BS"
                },
                {
                    "name": "Radiologic Sciences and Therapy",
                    "degree": "BS"
                },
                {
                    "name": "Respiratory Therapy",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
